//CHECKBOX
let checkboxFilter = document.querySelectorAll(".filter_checkbox");

checkboxFilter.forEach((el) => {
  if (el.querySelector("input").checked) {
    el.classList.add("active");
  }
  el.addEventListener("click", function (e) {
    if (this.classList.contains("active")) {
      this.querySelector("input").checked = false;
    } else {
      this.querySelector("input").checked = true;
    }
    this.classList.toggle("active");
    location.href = this.querySelector(".custom-control-input").getAttribute(
      "data-link"
    );
  });
});

// OPEN FILTER LIST
let addosFilterTitle = document.querySelectorAll(".block_addons_title_arrow");
for (let i = 0; i < addosFilterTitle.length; i++) {
  let filterList = addosFilterTitle[i].nextElementSibling;
  let arrowEl = addosFilterTitle[i].querySelector(".arrow");
  addosFilterTitle[i].addEventListener("click", function () {
    filterList.classList.toggle("open_list");
    addosFilterTitle[i]
      .querySelector(".arrow")
      .classList.toggle("arrow_rotate");
  });
}

//FITER RANGE
let slider = document.getElementById("slider_range");
let startValue = document.querySelector(".start_value");
let endValue = document.querySelector(".end_value");
slider &&
  noUiSlider.create(slider, {
    start: [
      slider.getAttribute("data-start-min"),
      slider.getAttribute("data-start-max"),
    ],
    connect: true,
    range: {
      min: parseInt(slider.getAttribute("data-min")),
      max: parseInt(slider.getAttribute("data-max")),
    },
    step: 1,
  });
slider &&
  slider.noUiSlider.on("update", function (values, handle) {
    startValue.innerHTML = "$ " + Math.trunc(values[0]);
    endValue.innerHTML = "$ " + Math.trunc(values[1]);
  });
let addonFilterButton = document.querySelector(".btn_addons_filter");
addonFilterButton &&
  document
    .querySelector(".btn_addons_filter")
    .addEventListener("click", applyFilterPrice);

function applyFilterPrice() {
  const request = new XMLHttpRequest();
  const url = filterUrl;
  console.log(url);
  const getValueSlider = slider.noUiSlider.get();
  const params =
    "formData=" +
    "p=" +
    getValueSlider[0] +
    "," +
    getValueSlider[1] +
    "&_csrf=" +
    jst_csrf;
  request.open("POST", url, true);
  request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  request.addEventListener("readystatechange", () => {
    if (request.readyState === 4) {
      if(request.status === 200) {
        window.location.href = request.responseText;
        // window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        window.location.href = "/404";
      }
    }
  });
  request.send(params);
}
// END OPEN FILTER LIST

// SET PRODUCT COLOR ON FILTER RANGE
// let productColor = "red";
try {
  if (document.querySelector(".noUi-connect") !== null) {
    document.querySelector(".noUi-connect").style =
      "background: " + productColor + ";";
  }
  if (document.querySelector(".noUi-handle") !== null) {
    for (let el of document.querySelectorAll(".noUi-handle")) {
      el.style = "background: " + productColor + ";";
    }
  }
} catch (err) {}
// END SET PRODUCT COLOR ON FILTER RANGE
